module.exports = "<svg id=\"e3418492-828e-41f9-8b67-18b6bd0b658a\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 30.23\"><title>envelope</title><path d=\"M3.49,0A3.53,3.53,0,0,0,2.07.29l21.8,18.59a2.06,2.06,0,0,0,2.26,0L47.93.29A3.53,3.53,0,0,0,46.51,0ZM.38,1.91A3.48,3.48,0,0,0,0,3.49V26.74a3.48,3.48,0,0,0,3.49,3.49h43A3.48,3.48,0,0,0,50,26.74V3.49a3.48,3.48,0,0,0-.38-1.58l-22,18.73a4.08,4.08,0,0,1-5.26,0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/envelope.svg
// module id = 560
// module chunks = 1